export const UPLOAD_NAME_TEXT_MATERIAL_IMAGE = 'text-material'
